import React from 'react';
import css from './mario.module.scss';
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import mario_sokoban from "../../../assets/images/extra/mario_sokoban.png";

const Mario: React.FC = () => (
    <div className={css.project} id="marioSokoban">
        <img src={mario_sokoban} alt=""/>
        <div className={css.projectInformationContainer}>
            <div className={css.projectName} style={{position: 'relative'}}>
                <h3>Mario Sokoban</h3>
            </div>

            <div className={css.info}>
                <Chip label="2016" variant="outlined" size='small'/>
            </div>
            <div className={css.infoSmallScreen}>
                <Chip label="2016" variant="outlined" size='small'/>
            </div>

            <h5 className={css.textSectionInfo}>Description:</h5>
            <p className={css.description}>It is a 2D video game where the main character is mario trying to solve puzzles.</p>

            <div className={css.learnMoreLink}>
                <p>Demo: <a className={css.link}
                            href='https://drive.google.com/open?id=1eT6fO_-yMnqtOmwdU07dxJq3yY9iiley'
                            rel="noopener noreferrer"
                            target="_blank">https://drive.google.com/open?id=1eT6fO_-yMnqtOmwdU07dxJq3yY9iiley</a>
                </p>
            </div>

            <div className={css.learnMoreLink}>
                <p>Source Code: <a className={css.link}
                                   href='https://github.com/adhess/mario_sokoban'
                                   rel="noopener noreferrer"
                                   target="_blank">https://github.com/adhess/mario_sokoban</a>
                </p>
            </div>

            <h5 className={css.textSectionInfo}>Keywords:</h5>
            <div className={css.keywords}>
                <Tooltip title="SDL">
                    <Chip label="SDL" color="primary" variant="outlined" size='small'/>
                </Tooltip>
                <Tooltip title="C language">
                    <Chip label="C language" color="primary" variant="outlined" size='small'/>
                </Tooltip>
            </div>

        </div>
    </div>
);

export default Mario;
